import { Collapse, CollapseItem, Upload, DatePicker, TimeSelect, Table, TableColumn, Tag, Input, Button, Select, Option, Popover } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import { Switch as LSwitch } from '@/components/index';
import 'element-ui/lib/theme-chalk/index.css';
import { EventBus } from '@/services/Event.js';
import SeriesResult from '@/components/user/ranking/series-result/series-result.vue'
import ClubResult from '@/components/user/ranking/club-result/club-result.vue'
import RacesList from '@/components/user/ranking/races-list/races-list.vue'

export default {
    name: 'RankingLayoutUser',
    components: {
        'series-result': SeriesResult,
        'club-result': ClubResult, 
        'races-list': RacesList,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        [Tag.name]: Tag,
        [Input.name]: Input,
        [Select.name]: Select,
        [Option.name]: Option,
        [Upload.name]: Upload,
        [Button.name]: Button,
        [Popover.name]: Popover,
        LSwitch,
    },
    data() {
        return {
            selectedYearIndex: 0,
            selectedSerieIndex: 0,
            isProcessing: false,
            errorMessage: null,
            options: ['Series', 'Club National Series - Triathlon Ireland', 'Races Results'],
            selectedOption: 'Series',
        };
    },
    methods: {
        serialize(obj) {
            var str = [];
            for (var p in obj)
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            return str.join("&");
        }
    },
    mounted() {
        if (window.location.hash.indexOf("race-results") != -1) {
            this.selectedOption = this.options[2];
        }
        else
        if (window.location.hash.indexOf("club-results") != -1) {
            this.selectedOption = this.options[1];
        }

        var self = this;
        EventBus.$off('ranking-layout-set-init-serie-index');
        EventBus.$on('ranking-layout-set-init-serie-index', tabIndex => self.selectedSerieIndex = tabIndex );

        EventBus.$off('ranking-layout-set-init-year-index');
        EventBus.$on('ranking-layout-set-init-year-index', tabIndex => self.selectedYearIndex = tabIndex );
    }
};



// WEBPACK FOOTER //
// ./src/components/user/ranking/ranking-layout/ranking-layout.js